module.exports = __webpack_public_path__ + "img/sides.1e59567.jpg";